import { render, staticRenderFns } from "./FinanicalInsights.vue?vue&type=template&id=df0e92bc"
import script from "./FinanicalInsights.vue?vue&type=script&lang=js"
export * from "./FinanicalInsights.vue?vue&type=script&lang=js"
import style0 from "./FinanicalInsights.vue?vue&type=style&index=0&id=df0e92bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports